import { type ControllerRenderProps, useController } from 'react-hook-form';
import { useFormRules } from '@doxyme/ui/hooks';
import type {
  InviteViaEmailFormReturn,
  InviteViaEmailFormValues,
} from '../inviteViaEmailForm.types';
import { useEffect } from 'react';

export const useTimeField = (
  form: InviteViaEmailFormReturn,
): ControllerRenderProps<InviteViaEmailFormValues, 'timeField'> => {
  const { validateTime } = useFormRules();

  const currentDateValue = form.watch('dateField');

  /**
   * When the date changes, we need to re-validate the time field.
   */
  useEffect(() => {
    void form.trigger('timeField');
  }, [currentDateValue]);

  return useController({
    name: 'timeField',
    defaultValue: null,
    control: form.control,
    rules: {
      validate: {
        validateTime,
        validatePastTime: (time) => {
          if (time === null) {
            return true;
          }

          return true;
        },
      },
    },
  }).field;
};
